<template>
  <transition name="show">
    <div class="rest-list-wrapper flex flex-col" >
      <div class="trlistwrapper" ref="rest_list" v-if="restaurants && !refresh">
        <div class="trlistitem" v-for="(item, index) in restaurants" :key="index">

          <item-grid-view :item="item.restaurant" :detail="cartButtonClicked" :ref="'restaurant'.concat(index)">
            <!-- SLOT: ACTION BUTTONS -->
          </item-grid-view>

        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'BlogRelatedRestaurant',
  beforeMount () {
  },
  props: {
    restaurants: {
      type: Array
    }
  },
  data () {
    return {
      refresh: false
    }
  },
  watch: {
  },
  components: {
    ItemGridView: () => import('../../restaurantlist/components/ItemGridView.vue')
  },
  computed: {
    isMobile () { return this.$store.state.api.isMobile }
  },
  methods: {
    cartButtonClicked (item) {
      this.$vs.loading()
      this.$router.push({
        name: 'restaurant-products',
        params: {
          restaurant_id: String(item.user_property['Alias']),
          related_items: this.restaurantlist
        }}).then(() => this.$vs.loading.close())
    }
  }
}
</script>
<style lang="scss">
</style>
